export const cities = ['Zurich', 'Geneva', 'Basel', 'Lausanne', 'Bern', 'Winterthur', 'Lucerne', 'St. Gallen', 'Lugano', 'Biel/Bienne'];

export const cityCoordinates = {
  'Zurich': { lat: 47.3769, lng: 8.5417 },
  'Geneva': { lat: 46.2044, lng: 6.1432 },
  'Basel': { lat: 47.5596, lng: 7.5886 },
  'Lausanne': { lat: 46.5197, lng: 6.6323 },
  'Bern': { lat: 46.9479, lng: 7.4474 },
  'Winterthur': { lat: 47.4990, lng: 8.7240 },
  'Lucerne': { lat: 47.0502, lng: 8.3093 },
  'St. Gallen': { lat: 47.4245, lng: 9.3767 },
  'Lugano': { lat: 46.0037, lng: 8.9511 },
  'Biel/Bienne': { lat: 47.1368, lng: 7.2467 }
};
